__turbopack_context__.v({
  "root": "group-module-scss-module__fwRXTa__root",
});
